import jQuery from 'jquery';
import autosize from 'autosize';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'rp-jquery-modal-lightbox';

export default class Notes {
    constructor(customConfig) {
        const defaultConfig = {
            $runnerRowWrapperElement: jQuery('.js-RC-runnerRowWrapper'),
            $buttonElements: jQuery('.js-RC-notesButtons'),
            $formElements: jQuery('.js-RC-notes'),
            newHorseSelector: '[data-ugc-runnerid]:not(.js-RC-UgcCommentsObtained)',
            formSelector: '.js-RC-notes',
            inputSelector: '.js-RC-notesInput',
            contentSelector: '.js-RC-noteContent',
            textareaSelector: '.js-RC-noteTextarea',
            ratingSelector: '.js-RC-noteRating',
            ratingColSelector: '.js-RC-runnerMr',
            oddsSelector: '.js-RC-noteOdds',
            selectionSelector: '.js-RC-checkboxInput',
            buttonsSelector: '.js-RC-notesButtons',
            saveButtonSelector: '.js-RC-buttonSave',
            resetButtonSelector: '.js-RC-buttonReset',
            inputValidationSelector: '.js-RC-validation',
            commentErrorMessageSelector: '.js-RC-validationMessage_myNote',
            commentErrorIconSelector: '.js-RC-validationIcon_myNote',
            ratingErrorMessageSelector: '.js-RC-validationMessage_myRating',
            ratingErrorIconSelector: '.js-RC-validationIcon_myRating',
            oddsErrorMessageSelector: '.js-RC-validationMessage_myOdds',
            oddsErrorIconSelector: '.js-RC-validationIcon_myOdds',
            loadingSpinnerSelector: '.js-RC-spinner',
            notesLightboxContentSelector: '.js-RC-notesLightbox__content',
            modalNotesSelector: '.js-RC-modalNotes',
            selectedHorseClass: 'js-RC-UgcCommentsObtained',
            inactiveButtonClass: 'ui-btn_primary--disabled',
            inactiveContentClass: 'RC-notes__content_inactive',
            inactiveTextareaClass: 'RC-notes__textarea_inactive',
            saveButtonClass: 'RC-notes__button_saved',
            uiHiddenClass: 'hidden',
            runnerRowSelector: '.js-RC-runnerRow',
            settingsButtonSelector: '.js-RC-runnerNotesBtn',
            settingsButtonHighlightClass: 'RC-runnerButtons__item_highlighted',
            errorMessageOdds: 'Please enter valid odds'
        };
        this.notes = {};
        this.tpl = jQuery('<div class="RC-notesLightbox" data-test-selector="RC-notesLightbox__error">' +
            '<div class="RC-notesLightbox__content js-RC-notesLightbox__content" data-test-selector="RC-notesLightbox__messageError">Sorry, could not save notes</div>' +
            '<button class="ui-btn ui-btn_primary RC-notesLightbox__button" data-test-selector="RC-notesLightbox__button"><span>OK</span></button>' +
            '</div>');
        this.config = jQuery.extend(true, {}, defaultConfig, customConfig);
        this.init();
    }

    init() {
        if (!this.isPro()) {
            return;
        }
        this.getNotes();
        this.bindEvents();
        this.tpl.rpModalBox({
            autoOpen: false,
            cssClass: 'RC-modal RC-modal_notes js-RC-modalNotes',
            showClose: false,
            autoClose: false
        });
    }

    isPro() {
        return this.config.$runnerRowWrapperElement.data('ugcTypecard') === 'pro';
    }

    bindEvents() {
        const $form = this.config.$formElements;

        this.config.bindedFunction = {
            onChangeHandler: jQuery.proxy(this.onChangeHandler, this),
            onKeyPressHandler: jQuery.proxy(this.onKeyPressHandler, this),
            onFocusHandler: jQuery.proxy(this.onFocusHandler, this),
            onSubmitHandler: jQuery.proxy(this.onSubmitHandler, this),
            onResetHandler: jQuery.proxy(this.onResetHandler, this)
        };
        $form.on('input change', this.config.bindedFunction.onChangeHandler);
        $form.on('keypress', this.config.bindedFunction.onKeyPressHandler);
        $form.on('focusin', this.config.bindedFunction.onFocusHandler);
        jQuery(this.config.saveButtonSelector).on('click', this.config.bindedFunction.onSubmitHandler);
        jQuery(this.config.resetButtonSelector).on('click', this.config.bindedFunction.onResetHandler);
        jQuery(window).on('dynamicPricesUpdated.NOTES', jQuery.proxy(this.onPricesUpdate, this));
    }

    onPricesUpdate() {
        this.getNotes();
        this.rebindFormHandlers();
    }

    rebindFormHandlers() {
        let $form = this.config.$formElements;

        $form.off('input change', this.config.bindedFunction.onChangeHandler);
        $form.off('keypress', this.config.bindedFunction.onKeyPressHandler);
        $form.off('focusin', this.config.bindedFunction.onFocusHandler);
        jQuery(this.config.saveButtonSelector).off('click', this.config.bindedFunction.onSubmitHandler);
        jQuery(this.config.resetButtonSelector).off('click', this.config.bindedFunction.onResetHandler);
        $form = jQuery(this.config.formSelector);
        this.config.$formElements = $form;
        $form.on('input change', this.config.bindedFunction.onChangeHandler);
        $form.on('keypress', this.config.bindedFunction.onKeyPressHandler);
        $form.on('focusin', this.config.bindedFunction.onFocusHandler);
        jQuery(this.config.saveButtonSelector).on('click', this.config.bindedFunction.onSubmitHandler);
        jQuery(this.config.resetButtonSelector).on('click', this.config.bindedFunction.onResetHandler);
    }

    onChangeHandler(event) {
        const $input = jQuery(event.target);
        const $form = $input.parents(this.config.formSelector);
        const $saveButton = $form.find(this.config.saveButtonSelector);
        const $resetButton = $form.find(this.config.resetButtonSelector);
        const horseId = $form.attr('id').replace('horse-', '');
        const savedHash = this.getSavedHash();
        const currentHash = this.getCurrentHash($form);

        $saveButton.removeClass(this.config.saveButtonClass);
        savedHash[horseId].odds = savedHash[horseId].odds === null ? '' : savedHash[horseId].odds;

        if (savedHash[horseId] &&
            JSON.stringify(savedHash[horseId]) === JSON.stringify(currentHash)) {
            this.disableButton($saveButton);
            this.disableButton($resetButton);
        } else {
            this.enableButton($saveButton);
            this.enableButton($resetButton);
        }
    }

    onFocusHandler(event) {
        const $form = jQuery(event.currentTarget);
        const focusTargetForm = jQuery(event.target).attr('name');
        const commentForm = $form.find(this.config.textareaSelector).attr('name');
        const ratingForm = $form.find(this.config.ratingSelector).attr('name');
        const oddsForm = $form.find(this.config.oddsSelector).attr('name');

        if (focusTargetForm === commentForm) {
            const $commentIcon = $form.find(this.config.commentErrorIconSelector);
            const $commentMessage = $form.find(this.config.commentErrorMessageSelector);

            $commentIcon.addClass(this.config.uiHiddenClass);
            $commentMessage.addClass(this.config.uiHiddenClass);
        }
        if (focusTargetForm === ratingForm) {
            const $ratingIcon = $form.find(this.config.ratingErrorIconSelector);
            const $ratingMessage = $form.find(this.config.ratingErrorMessageSelector);

            $ratingIcon.addClass(this.config.uiHiddenClass);
            $ratingMessage.addClass(this.config.uiHiddenClass);
        }
        if (focusTargetForm === oddsForm) {
            const $oddsIcon = $form.find(this.config.oddsErrorIconSelector);
            const $oddsMessage = $form.find(this.config.oddsErrorMessageSelector);

            $oddsIcon.addClass(this.config.uiHiddenClass);
            $oddsMessage.addClass(this.config.uiHiddenClass);
        }
    }

    onKeyPressHandler(event) {
        const button = event.which;
        const $target = jQuery(event.target);

        return !(button === 13 && !$target.is('textarea'));
    }

    getSavedHash() {
        return this.notes;
    }

    getCurrentHash($form) {
        const currentHash = {};

        $form.find(this.config.inputSelector).each((index, item) => {
            if (jQuery(item).attr('name') === 'selection') {
                currentHash[jQuery(item).attr('name')] = jQuery(item)[0].checked;
            } else {
                currentHash[jQuery(item).attr('name')] = jQuery(item).val();
            }
        });

        return currentHash;
    }

    onSubmitHandler(event) {
        const $form = jQuery(event.target).parents(this.config.formSelector);

        event.preventDefault();
        if (!this.validate($form)) {
            return;
        }
        this.saveNotes($form);
        this.drawNotes($form);
    }

    disableButton($button) {
        $button.attr('disabled', true);
        $button.addClass(this.config.inactiveButtonClass);
    }

    enableButton($button) {
        $button.attr('disabled', false);
        $button.removeClass(this.config.inactiveButtonClass);
    }

    validate(form) {
        const $form = jQuery(form);
        const $comment = $form.find(this.config.textareaSelector).val();
        const $rating = $form.find(this.config.ratingSelector).val();
        const $odds = $form.find(this.config.oddsSelector).val();
        const ratingRegex = [/^\d{1,3}$/g];
        const oddsRegex = [/^\d{0,4}\/\d{0,4}$/g, /^Evs$/gi];
        const error = {
            comment: [
                this.config.commentErrorMessageSelector,
                this.config.commentErrorIconSelector
            ],
            rating: [
                this.config.ratingErrorMessageSelector,
                this.config.ratingErrorIconSelector
            ],
            odds: [
                this.config.oddsErrorMessageSelector,
                this.config.oddsErrorIconSelector
            ]
        };
        const commentRule = $comment.length <= 250;
        const ratingRule = (!!$rating.match(ratingRegex[0]) && $rating.length < 4)
            || !$rating.length;
        const oddsRule = (!!$odds.match(oddsRegex[0]) && $odds.length < 7)
            || !!$odds.match(oddsRegex[1]) || !$odds.length;
        const rules = [commentRule, ratingRule, oddsRule];
        const valid = rules.indexOf(false) > -1;

        if (oddsRule) {
            error.odds.forEach(item =>
                $form.find(item).addClass(this.config.uiHiddenClass));
        } else {
            error.odds.forEach(item =>
                $form.find(item).removeClass(this.config.uiHiddenClass));
            error.rating.forEach(item =>
                $form.find(item).addClass(this.config.uiHiddenClass));
            error.comment.forEach(item =>
                $form.find(item).addClass(this.config.uiHiddenClass));

            return !valid;
        }
        if (ratingRule) {
            error.rating.forEach(item =>
                $form.find(item).addClass(this.config.uiHiddenClass));
        } else {
            error.rating.forEach(item =>
                $form.find(item).removeClass(this.config.uiHiddenClass));

            return !valid;
        }
        if (commentRule) {
            error.comment.forEach(item =>
                $form.find(item).addClass(this.config.uiHiddenClass));
        } else {
            error.comment.forEach(item =>
                $form.find(item).removeClass(this.config.uiHiddenClass));

            return !valid;
        }
        return !valid;
    }

    saveNotes(form) {
        const $form = jQuery(form);
        const $inputs = $form.find(':input:not(button)');
        const postData = this.processData($inputs);
        const $saveButton = $form.find(this.config.saveButtonSelector);
        const $resetButton = $form.find(this.config.resetButtonSelector);
        const horseId = postData.horse_id;
        const $horseElement = jQuery(`#horse-${horseId}`);

        this.notes[horseId] = {
            comment: postData.comment,
            odds: postData.odds,
            rating: postData.rating,
            selection: postData.selection
        };

        const notesPresent = Object.keys(this.notes[horseId])
            .some(note => this.notes[horseId][note]);
        const myRatingValue = this.notes[horseId].rating;

        this.disableButton($saveButton);
        this.disableButton($resetButton);
        jQuery.ajax({
            type: 'POST', url: '/racecards/ugc/save', data: postData
        })
            .done(jQuery.proxy(
                this.saveNotesSuccess,
                this,
                form,
                notesPresent,
                $horseElement,
                myRatingValue))
            .fail(jQuery.proxy(this.saveNotesError, this));
    }

    saveNotesSuccess(form, dataPresent, element, myRatingValue, message) {
        this.tpl.find('button').on('click', jQuery.proxy(this.destroyLightbox, this, form));
        this.destroyLightbox();
        if (message.success) {
            this.buttonHighlightHandler(dataPresent, element);
            this.updateMyRatingColumn(element, myRatingValue);
        } else if (message.field === 'odds') {
            this.activateLightbox(this.config.errorMessageOdds);
        } else {
            this.activateLightbox();
        }
    }

    destroyLightbox(form) {
        this.tpl.rpModalBox('close');
        jQuery(form).find(this.config.saveButtonSelector).removeClass(this.config.saveButtonClass);
    }

    activateLightbox(message) {
        if (message) {
            this.tpl.find(this.config.notesLightboxContentSelector).html(message);
        }
        this.tpl.rpModalBox('open');
    }

    saveNotesError(error) {
        // eslint-disable-next-line no-console
        console.log('saveNotesError', error);
    }

    processData($inputs) {
        const postData = {
            race_id: this.config.$runnerRowWrapperElement.attr('data-ugc-raceid'),
            horse_id: $inputs.parents(this.config.formSelector).attr('id').replace('horse-', '')
        };
        $inputs.each(jQuery.proxy(this.combine, this, postData));
        return postData;
    }

    combine(postData, index, value) {
        const data = postData;

        data[jQuery(value).attr('name')] = jQuery(value).val();
        if (jQuery(value).attr('name') === 'selection') {
            data.selection = jQuery(value)[0].checked ? 1 : 0;
        }
    }

    drawNotes(form) {
        const $form = jQuery(form);
        const $saveButton = $form.find(this.config.saveButtonSelector);

        $saveButton.addClass(this.config.saveButtonClass, 500);
    }

    onResetHandler(event) {
        event.preventDefault();
        const $form = jQuery(event.target).parents(this.config.formSelector);
        const $saveButton = $form.find(this.config.saveButtonSelector);
        const $resetButton = $form.find(this.config.resetButtonSelector);
        const horseId = $form.attr('id').replace('horse-', '');
        const savedHash = this.getSavedHash();

        if (savedHash[horseId]) {
            this.renderHorse(horseId, savedHash);
        }
        this.disableButton($saveButton);
        this.disableButton($resetButton);
    }

    processParams() {
        return {
            race_id: this.config.$runnerRowWrapperElement.attr('data-ugc-raceid'),
            horse_id: this.processHorseIds(),
            race_type_code: this.config.$runnerRowWrapperElement.attr('data-ugc-typecode')
        };
    }

    processHorseIds() {
        return jQuery(this.config.newHorseSelector).toArray().map((item) => {
            item.classList.add('js-RC-UgcCommentsObtained');

            return item.getAttribute('data-ugc-runnerid');
        });
    }

    getNotes() {
        const requestParams = this.processParams();
        const ugcUserHasNotes = this.checkUgcUserHasNotes();

        if (requestParams.horse_id.length && ugcUserHasNotes) {
            jQuery.ajax({
                type: 'GET',
                url: '/racecards/ugc',
                data: requestParams
            })
                .done(jQuery.proxy(this.getNotesSuccess, this, requestParams))
                .fail(jQuery.proxy(this.getNotesError, this, requestParams));
        }
    }

    checkUgcUserHasNotes() {
        let results = false;
        jQuery.ajax({
            async: false,
            type: 'GET',
            url: '/racecards/ugc/checknotes',
            success(res) {
                results = res.success ? res.ugcUserHasNotes : false;
            }
        });

        return results;
    }

    getNotesSuccess(requestParams, response) {
        requestParams.horse_id.forEach((horseId) => {
            const $horseElement = jQuery(`#horse-${horseId}`);

            if (response.success) {
                this.enable($horseElement);
            } else {
                $horseElement.find(this.config.contentSelector).text('Notes content unavailable');
            }
        }, this);
        if (response.success) {
            this.render(response.data);
            this.hash(response.data);
        }
    }

    getNotesError(requestParams) {
        requestParams.horse_id.forEach((horseId) => {
            const $horseElement = jQuery(`#horse-${horseId}`);

            $horseElement.find(this.config.contentSelector).text('Notes content unavailable');
        });
    }

    hash(data) {
        const $horses = jQuery(this.config.formSelector);

        if (jQuery.isArray(data)) {
            $horses.toArray()
                .forEach((value) => {
                    const horseId = jQuery(value).attr('id').replace('horse-', '');

                    this.notes[horseId] = {
                        comment: '',
                        rating: '',
                        odds: '',
                        selection: false
                    };
                });
        } else if ($horses.length > Object.keys(data).length) {
            $horses.toArray()
                .forEach((value) => {
                    const horseId = jQuery(value).attr('id').replace('horse-', '');

                    this.notes[horseId] = !data[horseId]
                        ? { comment: '', rating: '', odds: '', selection: false }
                        : data[horseId];
                });
        } else {
            this.notes = data;
        }
    }

    enable($horse) {
        const $horseElement = $horse;

        $horseElement.find(jQuery(this.config.inputSelector))
            .attr('disabled', false);
        $horseElement.find(this.config.contentSelector)
            .addClass(this.config.inactiveContentClass);
        $horseElement.find(this.config.textareaSelector)[0].placeholder = 'add a note...';
        $horseElement.find(this.config.textareaSelector)
            .removeClass(this.config.inactiveTextareaClass);
    }

    render(data) {
        Object.keys(data).forEach(horseId => this.renderHorse(horseId, data));
    }

    renderHorse(horseId, data) {
        const $horseElement = jQuery(`#horse-${horseId}`);
        const $textArea = $horseElement.find(this.config.textareaSelector);
        $textArea.val(data[horseId].comment);
        autosize.update($textArea);
        $horseElement.find(this.config.ratingSelector).val(data[horseId].rating);
        $horseElement.find(this.config.oddsSelector).val(data[horseId].odds);
        $horseElement.find(this.config.selectionSelector)[0].checked = !!data[horseId].selection;
        this.updateMyRatingColumn($horseElement, data[horseId].rating);
        // Additional check on empty notes for case when renderHorse is called from onResetHandler
        const notesPresent = Object.keys(data[horseId])
            .some(note => data[horseId][note]);
        this.buttonHighlightHandler(notesPresent, $horseElement);
    }

    buttonHighlightHandler(dataPresent, element) {
        const button = element.closest(this.config.runnerRowSelector)
            .find(this.config.settingsButtonSelector);

        if (dataPresent) {
            button.addClass(this.config.settingsButtonHighlightClass);
        } else {
            button.removeClass(this.config.settingsButtonHighlightClass);
        }
    }

    updateMyRatingColumn(element, value) {
        element
            .closest(this.config.runnerRowSelector)
            .find(this.config.ratingColSelector)
            .text(value ? `\u00A0${value}` : '\u00A0*')
            .attr('data-order-mr', value || 0);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/notes.js